import { useTranslation } from "react-i18next";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Radio, Typography, Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";

type ModalProps = {
    form?: FormInstance<any>;
    isModalVisible: boolean;
    isMinistry: boolean;
    isPublic?: boolean;
    handleOk: () => void;
    handleCancel: () => void;
    onFinishForm: (values: any) => void;
};

const QuickModerateModal: FunctionComponent<ModalProps> = ({
    form,
    isModalVisible,
    isMinistry,
    isPublic,
    handleOk,
    handleCancel,
    onFinishForm
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        title={t("Duyệt nhanh", "Duyệt nhanh")}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <div>
            {!isMinistry && isPublic ?
            <Typography.Text>
              {t("Nội dung sẽ được gửi lên cấp bộ sau khi duyệt", "Nội dung sẽ được gửi lên cấp bộ sau khi duyệt")}
            </Typography.Text>
            :
            <></>}
            
            <div className="footer-modal-button">
              <Button
                key="cancel"
                onClick={handleCancel}
                style={{ marginRight: "10px" }}
                icon={<CloseOutlined />}
              >
                {t("Huỷ bỏ", "Huỷ bỏ")}
              </Button>
              <Button
                key="ok"
                type="primary"
                onClick={handleOk}
                icon={<CheckOutlined />}
                style={{ marginLeft: "8px" }}
              >
                {t("Xác nhận", "Xác nhận")}
              </Button>
            </div>
          </div>,
        ]}
        className="modal-fast-browsing"
      >
        <Form form={form} onFinish={onFinishForm}>
          <p>{t("Nhập nội dung kiểm duyệt", "Nhập nội dung kiểm duyệt")}</p>
          <Form.Item name="status" initialValue={true}>
            <Radio.Group>
              <Radio value={true}>
                <Typography.Text>{t("Duyệt", "Duyệt")}</Typography.Text>
              </Radio>
              <Radio value={false}>
                <Typography.Text>{t("Không duyệt", "Không duyệt")}</Typography.Text>
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="description">
            <TextArea
              placeholder={t("Nhập ý kiến", "Nhập ý kiến")}
              style={{
                marginLeft: "60px",
                width: "80%",
                height: "45px",
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default QuickModerateModal;
